import React from 'react';
import ClientDefault from 'shared/components/client-card/ClientDefault';
// import ClientChecked from 'shared/components/client-card/ClientChecked';

class WorkoutAssignList extends React.Component {
  render() {
    const { unassignedClients } = this.props;
    return (
      <ul className="workout-client-list client-assign-list">
        {unassignedClients.length > 0 ?
          (
            unassignedClients.map(client => {
              return(
                <li key={client.id}>
                  <ClientDefault client={client} />
                </li>
              );
            })
          ) : (
            <h3>There is no Clients to be assigned!</h3>
          )
        }
      </ul>
    );
  }
}

export default WorkoutAssignList;
